<div class="mct-flex mct-col mct-gap-27" *ngIf="committee" ngModelGroup="committee">
  <div class="mct-grid mct-grid-lt-md mct-cols-1-lt-md mct-gap-27 committee-form-grid">
    <div class="area-header">
      <span class="section-header area-header">{{ 'committees.edit.committee-details.title' | translate | titlecase }}</span>
    </div>

    <div class="area-name">
      <label>{{ 'committees.edit.committee-details.committee-name' | translate | ucfirst }}</label>
      <input required name="committeeName" [(ngModel)]="committee.Name" />
    </div>

    <div class="area-notes">
      <label>{{ 'committees.edit.committee-details.internal-notes' | translate | ucfirst }}</label>
      <textarea pInputTextarea name="internalNotes" [(ngModel)]="committee.Notes"></textarea>
    </div>

    <div class="area-left-fields">
      <div class="mb-27">
        <label>{{ 'committees.edit.committee-details.committee-type' | translate | ucfirst }}</label>
        <p-select
          name="committeeType"
          [(ngModel)]="committee.CommitteeType"
          [options]="committeeTypeItems"
          [style]="{ width: '100%' }"
          [placeholder]="'committees.edit.committee-details.select-a-committee-type' | translate"
          showClear
        ></p-select>
      </div>
      <div>
        <label>{{ 'committees.edit.committee-details.committee-description' | translate | ucfirst }}</label>
        <textarea pInputTextarea name="committeeDescription" [(ngModel)]="committee.Descr"></textarea>
      </div>
    </div>

    <div class="area-right-fields">
      <div class="mb-27">
        <label>{{ 'committees.edit.committee-details.affiliation-code' | translate | ucfirst }}</label>
        <p-select
          name="affCode"
          [(ngModel)]="committee.AffCode"
          [options]="affCodeItems"
          [style]="{ width: '100%' }"
          [placeholder]="'committees.edit.committee-details.select-an-affiliation-code' | translate"
          showClear
        ></p-select>
      </div>
      <div>
        <label>{{ 'committees.edit.committee-details.assigned-to' | translate | ucfirst }}</label>
        <p-select
          name="assignedTo"
          [(ngModel)]="committee.AssignedTo"
          [options]="activeUserItems"
          [style]="{ width: '100%' }"
          [placeholder]="'committees.edit.committee-details.assign-this-committee-to' | translate"
          showClear
        ></p-select>
      </div>
    </div>
  </div>
  <hr />
  <div class="mct-flex mct-col mct-gap-27">
    <span class="section-header">{{ 'committees.edit.committee-details.committee-lifespan' | translate | titlecase }}</span>
    <div class="mct-flex mct-row">
      <p-checkbox name="active" binary="true" [(ngModel)]="committee.Active" inputId="committeeActive"> </p-checkbox>
      <label for="committeeActive">
        {{ 'committees.edit.committee-details.active' | translate | titlecase }}
      </label>
    </div>
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-28">
      <div>
        <label>{{ 'committees.edit.committee-details.start-date' | translate | ucfirst }}</label>
        <wl-date-selector name="startDate" appendTo="body" [(ngModel)]="committee.StartDate"></wl-date-selector>
      </div>
      <div>
        <label>{{ 'committees.edit.committee-details.end-date' | translate | ucfirst }}</label>
        <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-27">
          <wl-date-selector
            name="endDate"
            appendTo="body"
            [(ngModel)]="committee.EndDate"
            [disabled]="committee.OnGoing"
          ></wl-date-selector>
          <div class="mct-flex mct-row">
            <p-checkbox name="ongoing" binary="true" [(ngModel)]="committee.OnGoing" inputId="committeeOngoing"> </p-checkbox>
            <label for="committeeOngoing">
              {{ 'committees.edit.committee-details.ongoing' | translate | ucfirst }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="mct-flex mct-col mct-gap-27">
    <span class="section-header">{{ 'committees.edit.committee-details.term-settings-for-members' | translate | titlecase }}</span>
    <div class="mct-flex mct-row mct-justify-start mct-items-end mct-gap-10">
      <div>
        <label>{{ 'committees.edit.committee-details.default-term-for-members' | translate | ucfirst }}</label>
        <p-select
          name="defaultTerm"
          [(ngModel)]="selectedDefaultTerm"
          [style]="{ width: '100%', height: '36px' }"
          [options]="termOptions"
          (onChange)="termSettingsChange($event)"
        ></p-select>
      </div>
      <input
        *ngIf="selectedDefaultTerm === termSettingsEnum.Custom"
        name="customTerm"
        class="custom-term"
        type="number"
        min="0"
        [(ngModel)]="committee.TermMonths"
      />
    </div>
    <div class="mct-flex mct-row">
      <p-checkbox
        name="inactivateOnTermExpiration"
        binary="true"
        [(ngModel)]="committee.InactivateOnTermExpiration"
        inputId="inactivateOnTermExpiration"
      >
      </p-checkbox>
      <label for="inactivateOnTermExpiration">
        {{ 'committees.edit.committee-details.inactivate-members-on-expiration-date' | translate | ucfirst }}
      </label>
    </div>
  </div>
</div>
